import React from "react";
import './program.scss';
import ImageProgram from '../image/TET_6673.jpg';
import { data } from '../data/data.js';



function Program() {

    return (
        <section className="section program">
            <div className="container program__container">
                <div className="program__main">
                    <div className="program__main-img">
                        <img className="image-main" src={ImageProgram} alt="" />
                    </div>
                    <div className="program__sub-title">
                        <h3>НАША ПРОГРАМА</h3>
                        У нашому дитячому центрі ми створюємо умови для всебічного розвитку дітей. Ми пропонуємо різноманітні заняття, які допомагають дітям розвивати творчі, когнітивні, музичні та фізичні навички. Заняття проводяться в невеликих групах у сучасно обладнаних приміщеннях. Також ми проводимо активності на свіжому повітрі. Наші викладачі приділяють велику увагу індивідуальному підходу до кожної дитини, забезпечуючи комфортні умови для навчання та розвитку.
                    </div>
                </div>
                <div className="program__content">
                    {data.map(item => (
                        <div className="program__content-items" key={item.id}>
                            <div className="program__content-wrapp">
                                <h3>
                                    {`${item.title}`}
                                </h3>
                                <p>
                                    {`${item.discriotion}`}
                                </p>
                            </div>
                            <div className="program__content-image">
                                <img className="image-program" src={item.image} alt="image-prg" />
                            </div>
                        </div>
                    ))}

                </div>
            </div>
        </section>
    )
}
export default Program;